@if (validDefinition) {
  <div class="dated">
    <div class="date-input">
      <label>
        Start Date
      </label>
      <input
        id="{{ identifier }}{{ startAtSuffix }}"
        name="{{ identifier }}{{ startAtSuffix }}"
        type="date"
        class="form-control"
        required
        autocomplete="off"
        placeholder="MM/DD/YYYY"
        [ngClass]="{ 'is-invalid': !!startAtValidationError }"
        [disabled]="startAtDisabled"
        [ngModel]="configOption.startAt | date: 'yyyy-MM-dd'"
        (ngModelChange)="onStartAtChange($event)"
        />
      @if (startAtValidationError && startAtValidationError.message) {
        <div class="invalid-feedback">
          {{ startAtValidationError.message }}
        </div>
      }
    </div>
    <div class="date-input ms-1">
      <label>
        End Date
      </label>
      <input
        id="{{ identifier }}{{ endAtSuffix }}"
        name="{{ identifier }}{{ endAtSuffix }}"
        type="date"
        class="form-control"
        required
        autocomplete="off"
        placeholder="MM/DD/YYYY"
        [ngClass]="{ 'is-invalid': !!endAtValidationError }"
        [disabled]="endAtDisabled"
        [ngModel]="configOption.endAt | date: 'yyyy-MM-dd'"
        (ngModelChange)="onEndAtChange($event)"
        />
      @if (endAtValidationError && endAtValidationError.message) {
        <div class="invalid-feedback">
          {{ endAtValidationError.message }}
        </div>
      }
    </div>
    <div class="actions ms-2">
      <div class="action">
        @if (canDeactivate) {
          <a href="#" (click)="onDeactivateClick($event)">
            <fa-icon [icon]="['fas', 'stop-circle']" size="1x" />
            Deactivate
          </a>
        }
        @if (canCancelDeactivate) {
          <a href="#" (click)="onCancelDeactivateClick($event)">
            <fa-icon [icon]="['fas', 'undo']" size="1x" />
            Cancel
          </a>
        }
      </div>
    </div>
  </div>
} @else {
  <p class="alert alert-warning">
    Invalid configuration definition. At present only 'boolean' configuration values can be 'dated'.
  </p>
}
